const contractor = {
  wizardTitle: "Регистрация подрядчика",
  wizardSubtitle: "Подача заявки на регистрацию в реестре подрядчиков",
  stepBusiness: "Данные о бизнесе",
  stepLicense: "Лицензия и классификация",
  stepDocuments: "Документы",
  stepServiceArea: "Зона обслуживания",
  stepReview: "Проверка и отправка",
  businessName: "Название компании",
  businessId: "ИНН / ОГРН",
  phone: "Телефон",
  email: "Эл. почта",
  address: "Адрес",
  licenseNumber: "Номер лицензии подрядчика",
  classificationTier: "Уровень классификации",
  classificationCategory: "Категории классификации",
  insuranceCert: "Страховой сертификат",
  licenseScan: "Скан лицензии",
  documentsDesc: "Загрузите подтверждающие документы (необязательно — можно добавить позже)",
  licenseExpiry: "Срок действия лицензии",
  insuranceExpiry: "Срок действия страховки",
  serviceAreas: "Зоны обслуживания",
  back: "Назад",
  next: "Далее",
  submit: "Подать заявку",
  submissionSuccess: "Заявка успешно подана!",
  submissionSuccessDesc: "Наша команда рассмотрит вашу заявку и свяжется с вами в ближайшее время.",
  confirmationNumber: "Номер подтверждения",
} as const;
export default contractor;
